import * as angular from 'angular';

import './sites/siteDetail.component';
import './sites/sites.component';

import './users/userDetail.component';
import './users/users.component';

import './epx-units/epxUnitDetail.component';
import './epx-units/epxUnits.component';

import './report-schedules/reportScheduleDetail.component';
import './report-schedules/reportSchedules.component';

import './user-roles/userRoleDetail.component';

var templateUrl = require('./admin.html');

angular.module('ciApp').component('admin', {
  templateUrl: templateUrl,
  controller: function() {}
});



// WEBPACK FOOTER //
// ./app/admin/admin.component.ts